module.exports = __webpack_public_path__ + "img/Com.Geo.6cc0687e.svg";